// extracted by mini-css-extract-plugin
module.exports = {"content":"index-module_content_18Hb5","text-weight":"index-module_text-weight_YsC9q","text-align":"index-module_text-align_1mAsN","link":"index-module_link_28EAL"};